import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, ReadonlyHttpApiRepository, Result } from '@softline/core';
import { Objekt } from './objekt';
import { SOFTLINE_API_OBJECT_SCAN } from '../wws-core.api';
import { Scan } from '@softline/application';

@Injectable({ providedIn: 'root' })
export class ScanObjektRepository extends ReadonlyHttpApiRepository<Result<Objekt>, { scan: Scan }> {

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_OBJECT_SCAN);
  }

  protected override getLoadPathParams(params: {scan: Scan}): Dictionary<unknown> | undefined {
    return {...params.scan};
  }
}
